import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;

  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;

  border-top: 1px solid ${Colors.GS400};

  padding: 8px 0px;

  &:last-child {
    border-bottom: 1px solid ${Colors.GS400};
  }
`

export const Nickname = styled.div`
  margin-left: 16px;
  margin-right: auto;
`
